export const appendIfUnique = (params: any, key: any, value: any) => {
  const existing = params.get(key);
  if (existing === value) return;
  params.append(key, value);
};
